import { LobbyType } from '../../features/workflow/types.ts';

export const ReportingEndpoints = {
  reporting: {
    checkoutReport: {
      get: (startDate: string, endDate: string) => `/api/CheckoutReport?startDate=${startDate}&endDate=${endDate}`,
      send: (startDate: string, endDate: string) => `/api/CheckoutReport/Send?startDate=${startDate}&endDate=${endDate}`
    },
    agentActivityReport: {
      activity: (start: string, end: string, segment?: string) => {
        const params = new URLSearchParams({ start, end });
        if (segment) params.append('segment', segment);
        return `/api/AgentActivityReport/activity?${params.toString()}`;
      },
      /** GET current user's completed bookings (snapshot); optional start/end/flsqNumber query params */
      myReport: (start?: string, end?: string, flsqNumber?: string) => {
        const params = new URLSearchParams();
        if (start) params.append('start', start);
        if (end) params.append('end', end);
        if (flsqNumber !== undefined && flsqNumber !== null && flsqNumber !== '')
          params.append('flsqNumber', String(flsqNumber));
        const query = params.toString();
        return query
          ? `/api/AgentActivityReport/activity/my-report?${query}`
          : `/api/AgentActivityReport/activity/my-report`;
      },
      folio: (start: string, end: string, segment?: string) => {
        const params = new URLSearchParams({ start, end });
        if (segment) params.append('segment', segment);
        return `/api/AgentActivityReport/folio?${params.toString()}`;
      },
      sendFolio: (start: string, end: string) => `/api/AgentActivityReport/folio/send?start=${start}&end=${end}`,
      sendActivity: (start: string, end: string) => `/api/AgentActivityReport/activity/send?start=${start}&end=${end}`,
      metaData: (propertyName: string, group: LobbyType, userIds: string[], start?: string, end?: string) => {
        const params = new URLSearchParams();
        if (start) params.append('start', start ?? '');
        if (end) params.append('end', end ?? '');
        params.append('group', LobbyType[group]);
        userIds.forEach((id) => params.append('userIds', id));
        return `/api/AgentActivityReport/metadata/${propertyName}?${params.toString()}`;
      }
    },
    clientEmailReport: {
      getClientEmailReport: (page: number, pageSize: number, orderBy?: string, isDesc?: boolean) => {
        let toReturn = `/api/ClientEmailReport?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      }
    },
    issueTrackReport: {
      getReport: (page: number, pageSize: number, orderBy?: string, isDesc?: boolean) => {
        let toReturn = `/api/IssueTrackReport?page=${page}&pageSize=${pageSize}`;
        if (orderBy !== undefined) {
          toReturn += `&orderBy=${orderBy}`;
        }
        if (isDesc !== undefined) {
          toReturn += `&isDesc=${isDesc}`;
        }
        return toReturn;
      },
      exportToExcel: '/api/IssueTrackReport/ExportToExcel',
      frontier: {
        create: `/api/IssueTrackReport/frontier/addIssue`,
        update: (frontierIssueId: number) => `/api/IssueTrackReport/frontier/updateIssue/${frontierIssueId}`,
        getById: (frontierIssueId: number) => `/api/IssueTrackReport/frontier/${frontierIssueId}`
      }
    },
    reconciliationReport: {
      get: (startDate?: string, endDate?: string) => {
        const params = new URLSearchParams();
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        const query = params.toString();
        return query ? `/api/PreRecReport?${query}` : `/api/PreRecReport`;
      },
      exportToExcel: '/api/PreRecReport/ExportToExcel'
    }
  }
};
